import React from 'react'
import {Link} from 'react-router'
import classNames from 'classnames'

const TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
}

export const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
}

const BaseButton = ({
  // text,
  children,
  onClick,
  className = '',
  type = 'button',
  disabled = false,
  buttonType = TYPES.PRIMARY,
  buttonSize = SIZES.MEDIUM,
  outline = false,
  target = '_self',
  href = null,
  style,
  ...custom
}) => {

  const classes = classNames({
    'outline': outline,
    'mabna-button': true,
    [`${buttonType}`]: true,
    [`${buttonSize}`]: true,
    'disabled': disabled,
    'block': custom.hasOwnProperty('block') || false
  })

  const props = {
    type: type,
    disabled: disabled,
    onClick: onClick,
    className: `${classes} ${className}`,
    style: style,
  }

  if (href) return <Link to={href} target={target} {...props}>{children}</Link>

  return (<button {...props}>
    {children}
  </button>)
}

export const Primary = props => (
  <BaseButton { ...props } buttonType={TYPES.PRIMARY}>{props.children}</BaseButton>
)
export const Secondary = props => (
  <BaseButton { ...props } buttonType={TYPES.SECONDARY}>{props.children}</BaseButton>
)
export const Warning = props => (
  <BaseButton { ...props } buttonType={TYPES.WARNING}>{props.children}</BaseButton>
)
export const Danger = props => (
  <BaseButton { ...props } buttonType={TYPES.DANGER}>{props.children}</BaseButton>
)
export const Success = props => (
  <BaseButton { ...props } buttonType={TYPES.SUCCESS}>{props.children}</BaseButton>
)



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js